import React, { useEffect, useState } from "react";
import { Api } from "../Api/Api";
import { useNavigate } from "react-router-dom";

const DeductProfit = () => {
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      const res = await fetch(`${Api}customers/list.php`);
      const data = await res.json();

      const filtered = (data.customers || []).filter(
        (c) => c.investment_type === "deduct_profit",
      );

      setCustomers(filtered);
    } catch (err) {
      console.error("Error loading customers", err);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">
        Deduct From Profit Customers
      </h1>

      <div className="bg-white rounded-xl shadow overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="bg-gray-900 text-white">
            <tr>
              <th className="p-3">S.No</th> {/* ✅ NEW */}
              <th className="p-3">Code</th>
              <th className="p-3">Name</th>
              <th className="p-3">Mobile</th>
              <th className="p-3">Investment</th>
              <th className="p-3">Weekly</th>
              <th className="p-3">Given Date</th>
              <th className="p-3">Status</th>
              <th className="p-3 text-center">Action</th> {/* ✅ NEW */}
            </tr>
          </thead>

          <tbody>
            {customers.length > 0 ? (
              customers.map((c, index) => (
                <tr key={c.id} className="border-b hover:bg-gray-50">
                  <td className="p-3 font-semibold">
                    {index + 1} {/* ✅ S.NO */}
                  </td>

                  <td className="p-3 font-mono">{c.customer_code}</td>
                  <td className="p-3">{c.name}</td>
                  <td className="p-3">{c.mobile1}</td>

                  <td className="p-3">
                    ₹{Number(c.investment_amount).toLocaleString()}
                  </td>

                  <td className="p-3">
                    ₹{Number(c.weekly_interest_amount).toLocaleString()}
                  </td>

                  <td className="p-3">{c.given_date}</td>

                  <td className="p-3">
                    <span
                      className={`px-2 py-1 rounded text-xs font-bold ${
                        c.status === "Active"
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-200 text-gray-700"
                      }`}
                    >
                      {c.status}
                    </span>
                  </td>

                  {/* ✅ VIEW BUTTON */}
                  <td className="p-3 text-center">
                    <button
                      // onClick={() => navigate(`/admin/customers/${c.id}`)}
                      onClick={() =>
                        navigate(`/admin/customers/${c.id}`, {
                          state: { from: "deduct-profit" },
                        })
                      }
                      className="px-3 py-1 bg-blue-600 text-white rounded-lg text-xs hover:bg-blue-700"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center p-5 text-gray-500">
                  No Deduct Profit Customers Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DeductProfit;
